
const data = {
    "products": [
      {
        "id": 1,
        "name": "Stone and Beam Westview",
        "price": 193,
        "category": "sofa",
        "image": "/images/double-sofa-01.png"
      },
      {
        "id": 2,
        "name": "Rivet Bigelow Modern",
        "price": 200,
        "category": "sofa",
        "image": "/images/double-sofa-02.png"
      },
      {
        "id": 3,
        "name": "Baltsar Chair",
        "price": 89,
        "category": "chair",
        "image": "/images/arm-chair-01.jpg"
      },
      {
        "id": 4,
        "name": "Helmar Chair",
        "price": 112,
        "category": "chair",
        "image": "/images/arm-chair-02.jpg"
      },
      {
        "id": 5,
        "name": "Realme 8",
        "price": 400,
        "category": "phone",
        "image": "/images/phone-01.jpg"
      },
      {
        "id": 6,
        "name": "One Plus Nord",
        "price": 790,
        "category": "phone",
        "image": "/images/phone-02.jpg"
      },
      {
        "id": 7,
        "name": "Apple Iphone 12 Pro",
        "price": 799,
        "category": "phone",
        "image": "/images/phone-03.png"
      },
      {
        "id": 8,
        "name": "Apple Iphone 12 Max",
        "price": 800,
        "category": "phone",
        "image": "/images/phone-04.jpg"
      },
      {
        "id": 9,
        "name": "Realme 8",
        "price": 200,
        "category": "phone",
        "image": "/images/phone-05.jpg"
      },
      {
        "id": 10,
        "name": "One Plus Nord",
        "price": 600,
        "category": "phone",
        "image": "/images/phone-02.jpg"
      },
      {
        "id": 11,
        "name": "Apple Iphone 13 Pro",
        "price": 900,
        "category": "phone",
        "image": "/images/phone-06.jpg"
      },
      {
        "id": 12,
        "name": "Samsung Glaxy S22",
        "price": 699,
        "category": "phone",
        "image": "/images/phone-02.jpg"
      },
      {
        "id": 13,
        "name": "Beat Studio Wireless",
        "price": 199,
        "category": "Wireless",
        "image": "/images/wireless-04.png"
      },
      {
        "id": 14,
        "name": "Beat EP Headphones",
        "price": 200,
        "category": "Headphone",
        "image": "/images/wireless-03.png"
      },
      {
        "id": 15,
        "name": "Black Headphones",
        "price": 300,
        "category": "Headphone",
        "image": "/images/wireless-02.png"
      },
      {
        "id": 16,
        "name": "Bluetooth Headphones",
        "price": 280,
        "category": "Headphone",
        "image": "/images/wireless-04.png"
      },
      {
        "id": 17,
        "name": "Stone and Beam Westview",
        "price": 158,
        "category": "sofa",
        "image": "/images/double-sofa-01.png"
      },
      {
        "id": 18,
        "name": "Rivet Bigelow Modern",
        "price": 250,
        "category": "sofa",
        "image": "/images/double-sofa-02.png"
      },
      {
        "id": 19,
        "name": "Amazon Brand Modern Sofa",
        "price": 180,
        "category": "sofa",
        "image": "/images/double-sofa-03.png"
      },
      {
        "id": 20,
        "name": "Rivet Bigelow Modern",
        "price": 290,
        "category": "sofa",
        "image": "/images/double-sofa-02.png"
      },
      {
        "id": 21,
        "name": "Fllufy Sheep Sofa",
        "price": 160,
        "category": "chair",
        "image": "/images/single-sofa-01.jpg"
      },
      {
        "id": 22,
        "name": "Faux Velvet Sofa",
        "price": 170,
        "category": "chair",
        "image": "/images/single-sofa-02.jpg"
      },
      {
        "id": 23,
        "name": "Fllufy Sheep Sofa",
        "price": 160,
        "category": "chair",
        "image": "/images/single-sofa-03.jpg"
      },
      {
        "id": 24,
        "name": "Modern Arm Sofa",
        "price": 290,
        "category": "chair",
        "image": "/images/single-sofa-04.png"
      }
    ]
  }


  export default data;